export default __webpack_public_path__ + "static/media/mobile_banner_miscellaneous.ac961217.jpg";